<template>
    <div class="fs5-affiliate-profile">
        <div class="fs5-ap-card" >
            <div class="fs5-ap-card-header">
                <span class="fs5-ap-card-header-title" v-html="view.header.title" ></span>
                <div class="fs5-tooltip-icon">
                    <svg
                        v-if="view.header.showTooltip"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 16 16"
                        class="icon"
                        data-toggle="tooltip"
                        rel="tooltip"
                        data-placement="bottom"
                        data-html="true"
                        :data-title="view.header.tooltip"
                    >
                        <path d="M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16ZM8 1.16C4.228 1.16 1.159 4.2275 1.159 8C1.159 11.7715 4.228 14.84 8 14.84C11.772 14.84 14.841 11.7715 14.841 8C14.841 4.2275 11.772 1.16 8 1.16Z" fill="#0080FC"/>
                        <path d="M8.16495 12.1515C8.10345 12.128 8.03694 12.09 8.03694 11.929C8.03694 11.8625 8.04745 11.7855 8.07094 11.6915L9.08145 6.79301C9.10445 6.67801 9.11595 6.55751 9.11595 6.43751C9.11595 6.12101 9.01794 5.88001 8.82544 5.72051C8.39394 5.36601 7.63895 5.43551 6.38294 5.86001L6.26144 5.90101L6.21144 6.53301H6.42244C7.06144 6.53301 7.21594 6.58301 7.24794 6.59851C7.29095 6.61901 7.31445 6.64351 7.31445 6.71551C7.31445 6.75551 7.30944 6.80051 7.29945 6.85051C7.28645 6.91701 7.27194 6.99401 7.25694 7.07701L6.33094 11.576C6.28794 11.8025 6.26594 11.997 6.26594 12.152C6.26594 12.5105 6.36894 12.7875 6.57144 12.9745C6.77094 13.157 7.04194 13.25 7.37944 13.25C7.77345 13.25 8.30295 13.1405 8.99695 12.916L9.12095 12.876L9.17094 12.2355H8.96044C8.48594 12.2355 8.26645 12.1895 8.16495 12.1515Z" fill="#0080FC"/>
                        <path d="M9.49553 3.02455C9.30453 2.84305 9.05953 2.75005 8.76753 2.75005C8.46503 2.75005 8.20903 2.84955 8.00753 3.04505C7.80453 3.24155 7.70103 3.50605 7.70103 3.83205C7.70103 4.13205 7.79953 4.38105 7.99303 4.57405C8.18703 4.76855 8.43453 4.86705 8.72903 4.86705C9.02853 4.86705 9.28203 4.76255 9.48453 4.55855C9.68553 4.35455 9.78753 4.08955 9.78753 3.77055C9.78753 3.45905 9.68953 3.20805 9.49553 3.02455Z" fill="#0080FC"/>
                    </svg>
                </div>
            </div>
            <div class="fs5-ap-card-content" >
                <div class="fs5-ap-left-content">
                    <div class="fs5-ap-left-content-title" v-html="view.content.left.title" >
                    </div>
                    <textarea
                        rows="7"
                        :maxlength="maxlengthbio"
                        v-model="bioText"
                        class="fs5-ap-left-content-textarea"
                    ></textarea>
                    <div class="fs5-ap-left-content-row">
                        <div class="fs5-ap-left-content-counter" >{{bioTextRemainingChars}} {{this.view.content.left.remainingCharacter}}</div>
                        <fs5-button 
                            :label="view.content.left.button.label"
                            :btn-type="view.content.left.button.btnType"
                            :text-transform-type="view.content.left.button.textTransformType"
                            @clicked="updateBio(view.content.left.button.link)"
                        ></fs5-button>
                    </div>

                    <div class="fs5-ap-loader" v-show="loading" >
                        <spring-spinner
                            :animation-duration="2000"
                            :size="50"
                            color="#0080fc"
                        />
                    </div>
                </div>
                <div class="fs5-ap-right-content">
                    <div class="fs5-ap-right-content-title" v-html="view.content.right.title" ></div>
                    <div class="fs5-ap-right-content-input-group">
                        <label for="email" v-html="view.content.right.emailLabel"></label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            disabled
                            placeholder="Ex: builderall@empresa.com.br"
                            v-model="view.dados_usuario_office.email"
                        />
                    </div>
                    <div class="fs5-ap-right-content-row-buttons">
                        <fs5-button 
                            :label="view.content.right.buttons[0].label"
                            :btn-type="view.content.right.buttons[0].btnType"
                            :text-transform-type="view.content.right.buttons[0].textTransformType"
                            @clicked="openTab(view.content.right.buttons[0].link)"
                        ></fs5-button>
                        <fs5-button 
                            :label="view.content.right.buttons[1].label"
                            :btn-type="view.content.right.buttons[1].btnType"
                            :text-transform-type="view.content.right.buttons[1].textTransformType"
                            :disabled="view.content.right.buttons[1].disabled"
                        ></fs5-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import qs from "qs";
    import { SpringSpinner } from 'epic-spinners'

    export default {
        name: 'fs5-affiliate-profile',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data: function() {
            return {
                bioText: '',
                maxlengthbio: 200,
                loading: false
            }
        },
        mounted(){
            this.bioText = this.view.dados_usuario_office.biography == null ? '' : this.view.dados_usuario_office.biography;
        },
        computed: {
            bioTextRemainingChars: function() {
                // if (this.bioText.length > this.maxlengthbio) this.helperStyleError = [{color:'red'}];
                return (this.maxlengthbio - this.bioText.length)
            }
        },
        methods: {
            openTab(link) {
                window.open(link, '_blank')
            },
            updateBio: async function(link) {
                if (this.bioText.length > this.maxlengthbio) {
                    alertMsg('error','ULTRAPASSOU OS CARACTERES')
                }
                else {
                    let vm = this;
                    vm.loading = true;
                    try{
                        let resposta = await axios.post(
                            link,
                             qs.stringify({ biography: vm.bioText })
                        );
                        alertMsg(resposta.data.status, resposta.data.msg)
                    } catch (error) {
                        alertMsg('error', 'Network Error');
                    } finally {
                        vm.loading = false;
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-affiliate-profile{
        font: inherit;
        position: relative;
        transition: 0.4s all;
        overflow: hidden;

        .fs5-ap-card{
            font: inherit;
            border: 1px $fs5-color1 solid;
            border-radius: 0.8em;
            background-color: $fs5-color2;
            
            .fs5-ap-card-header{
                font: inherit;

                border-radius: 0.8em 0.8em 0 0;
                background-color: $fs5-color3;
                padding: 1em 0 1.4em 0;

                display: flex;
                align-items: center;
                justify-content: center;

                span{
                    font: inherit;
                    font-size: 2.4em;
                    line-height: 1.2;
                    font-weight: 700;
                    text-align: center;
                    text-transform: capitalize;
                    color: $fs5-color2;
                }
                .fs5-tooltip-icon{
                    font: inherit;
                    display: inline-block;
                    margin-left: 1.8em;
                    .icon{
                        font: inherit;
                        width: 1.6em;
                        height: auto;
                    }
                    &:hover{
                        cursor: pointer;
                    }
                }
            }

            .fs5-ap-card-content{
                font: inherit;
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: auto;
                .fs5-ap-left-content{
                    font: inherit;
                    border-right: 1px $fs5-color1 solid;
                    padding: 3.9em 5.2em 4.8em 5.2em;
                    position: relative;
                    .fs5-ap-left-content-title{
                        font: inherit;
                        font-size: 1.6em;
                        font-weight: 700;
                        line-height: 1.2;
                        color: $fs5-color24;
                        padding-right: 3.6875em;
                        
                        margin-bottom: 1.75em;
                    }
                    .fs5-ap-left-content-textarea{
                        font: inherit;
                        font-size: 1.4em;
                        line-height: 1.2;
                        font-weight: 300;

                        padding: 1.78em;

                        outline: 0;
                        border: 1px $fs5-color25 solid;
                        color: $fs5-color24;

                        width: 100%;
                        min-height: 14.285714286em;
                        border-radius: 0.4em;
                    }

                    .fs5-ap-left-content-row{
                        font: inherit;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-template-rows: auto;
                        justify-content: stretch;
                        align-items: start;

                        column-gap: 5px;

                        margin-top: 1.4em;

                        .fs5-ap-left-content-counter{
                            font: inherit;
                            font-size: 1.3em;
                            line-height: 1.2;
                            font-weight: 700;

                            color: $fs5-color26;

                            padding-left: 3.4em;
                        }
                    }
                    .fs5-ap-loader{
                        font: inherit;
                        position: absolute;
                        top: 5.3em;
                        left: 0;
                        width: 100%;
                        height: calc(100% - 5.3em);
                        background-color: $fs5-color2;

                        background-color: $fs5-color2;
                        border-radius: 0.8em;

                        display: flex;
                        justify-content: center;
                        align-items: center;

                        opacity: 0.95;

                        transition: 0.4s all;
                    }
                }
                .fs5-ap-right-content{
                    font: inherit;
                    padding: 3.9em 5.2em 4.8em 5.2em;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .fs5-ap-right-content-title{
                        font: inherit;
                        font-size: 1.6em;
                        font-weight: 700;
                        line-height: 1.2;
                        color: $fs5-color24;
                        
                        margin-bottom: 2.625em;
                    }
                    .fs5-ap-right-content-input-group{
                        font: inherit;
                        display: flex;
                        flex-direction: column;
                        row-gap: 1em;
                        label{
                            font: inherit;
                            font-size: 1.4em;
                            line-height: 1.2;
                            font-weight: 700;
                            color: $fs5-color27;
                        }

                        input{
                            font: inherit;
                            font-size: 1.4em;
                            line-height: 1.2;
                            padding: 1.071428571em 1.428571429em;
                            color: $fs5-color24;


                            border: 1px $fs5-color25 solid;
                            border-radius: 0.285714286em;
                            outline: 0;
                            
                        }
                    }
                    .fs5-ap-right-content-row-buttons{
                        font: inherit;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-template-rows: auto;
                        column-gap: 2.2em;
                        justify-content: stretch;
                        align-items: center;

                        margin-top: 1.9em;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1365px) {
        .fs5-affiliate-profile{
            .fs5-ap-card{
                .fs5-ap-card-content{
                    grid-template-columns: 1fr;
                    .fs5-ap-left-content{
                        border-right: 0;
                        .fs5-ap-left-content-title{
                            text-align: center;
                            padding: 0;
                        }
                    }
                    .fs5-ap-right-content{
                        .fs5-ap-right-content-title{
                            text-align: center;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1024px) {
        .fs5-affiliate-profile{
            .fs5-ap-card{
                .fs5-ap-card-content{
                    .fs5-ap-right-content{
                        .fs5-ap-right-content-affiliate-link{
                            grid-template-columns: 20% auto 11.7400419%;
                        }
                        .fs5-ap-right-content-row-buttons{
                            grid-template-columns: 1fr;
                            row-gap: 1em;
                        }
                    }
                }
            }
        }
    }
</style>
<style lang="scss">
    @import '../../../../../scss/extras/_variables';
    .fs5-affiliate-profile{
        .fs5-ap-card{
            .fs5-ap-card-header{
                .fs5-tooltip-icon{
                    .tooltip{
                        .tooltip-inner{
                            font-family: $fs5-font2!important;
                            font-size: 14px;
                            padding: 10px!important;
                            border-radius: 4px!important;
                        }
                    }
                }
            }
            .fs5-ap-card-content{
                .fs5-ap-right-content{
                    .fs5-ap-right-content-affiliate-link{
                        .tooltip{
                            .tooltip-inner{
                                font-family: $fs5-font2!important;
                                font-size: 14px;
                                padding: 10px!important;
                                border-radius: 4px!important;
                            }
                            .tooltip-arrow{
                                border-top-color:  black!important;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/affiliate_dashboard/setup_affiliate_profile/index.vue